import { helpers } from '@vuelidate/validators'

export const checkedIf = (conditional) =>
  helpers.withParams({ type: 'checkedIf', conditional }, value => {
    return !conditional() || !!value
  })

export const checked = (value) => !!value
